export default "__VITE_ASSET__DCWflHve__"